var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpgrades = function SvgUpgrades(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.79,
    cy: 63.83,
    r: 1.23,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.82,
    cy: 53.33,
    r: 1.73,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M56.49 9H39.16A6.21 6.21 0 0 0 33 15.2a1 1 0 0 0 2 0 4.2 4.2 0 0 1 4.2-4.2h17.29a4.2 4.2 0 0 1 4.2 4.2v41.6a4.2 4.2 0 0 1-4.2 4.2H39.16A4.2 4.2 0 0 1 35 56.8V46.5h6.36l-2 2a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0l3.73-3.73a1.1 1.1 0 0 0 .22-.33 1 1 0 0 0 0-.76 1.1 1.1 0 0 0-.22-.33l-3.73-3.73a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l2 2H35V29.07a1 1 0 0 0-2 0V32H21.62a4.71 4.71 0 0 0-4.7 4.7v29.6a4.71 4.71 0 0 0 4.7 4.7H34a4.71 4.71 0 0 0 4.7-4.7V63a4 4 0 0 0 .5 0h17.29a6.21 6.21 0 0 0 6.2-6.2V15.2a6.21 6.21 0 0 0-6.2-6.2M36.66 66.3A2.7 2.7 0 0 1 34 69H21.62a2.71 2.71 0 0 1-2.7-2.7V36.7a2.71 2.71 0 0 1 2.7-2.7H33v10.5h-4.82a1.4 1.4 0 0 0-.2 0 1 1 0 0 0-.19 0 4 4 0 1 0 0 8 1 1 0 0 0 0-2 2 2 0 1 1 0-4 1 1 0 0 0 .19 0 1.4 1.4 0 0 0 .2 0H33v10.3a6.2 6.2 0 0 0 3.7 5.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.42 20.53c4.46 0 5.07.62 5.07 5.07a1 1 0 0 0 2 0c0-4.45.62-5.07 5.07-5.07a1 1 0 0 0 0-2c-4.45 0-5.07-.61-5.07-5.06a1 1 0 0 0-2 0c0 4.45-.61 5.06-5.07 5.06a1 1 0 0 0 0 2m6.07-2a3.6 3.6 0 0 0 1 1 3.6 3.6 0 0 0-1 1 3.6 3.6 0 0 0-1-1 3.6 3.6 0 0 0 1-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.56 21.57a1 1 0 0 0-1 1c0 1.93-.1 2-2 2a1 1 0 0 0 0 2c1.94 0 2 .1 2 2a1 1 0 0 0 2 0c0-1.93.09-2 2-2a1 1 0 0 0 0-2c-1.94 0-2-.1-2-2a1 1 0 0 0-1-1"
  })));
};
export default SvgUpgrades;